import React, { Suspense } from 'react';

import LocalStorageGoogleAuthScopeProvider from '../../global/jsx/integrations/google/LocalStorageGoogleAuthScopeProvider';
import { LOCAL_SCOPE_STORAGE_ID } from './data/EmailsListingContext';
import EmailsListingLoadingState from './EmailsListingLoadingState';

const EmailsListing = React.lazy(() => import(/* webpackChunkName: "EmailsListing" */ './EmailsListing'));

const GmailProvider = React.lazy(() => import(/* webpackChunkName: "EmailsListingProvider" */ './data/EmailsListingGmailProvider'));

const OutlookProvider = React.lazy(() => import(/* webpackChunkName: "EmailsListingProvider" */ './data/EmailsListingOutlookProvider'));

export default class EmailsListingLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <EmailsListing {...this.config} />;
        const dataProvider = this._getDataProvider(component);

        return <Suspense fallback={<EmailsListingLoadingState {...this.config} />}>{dataProvider}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }

    _getDataProvider(component) {
        const { datasource, localStorageKey, clientId, scopeApprovalSource } = this.config;
        if (datasource === 'gmail') {
            const wrappedComponent = <GmailProvider clientId={clientId}>{component}</GmailProvider>;

            if (scopeApprovalSource === 'localstorage') {
                return (
                    <LocalStorageGoogleAuthScopeProvider localStorageKey={localStorageKey || LOCAL_SCOPE_STORAGE_ID}>
                        {wrappedComponent}
                    </LocalStorageGoogleAuthScopeProvider>
                );
            }
            return wrappedComponent;
        }

        if (datasource === 'outlook') {
            return <OutlookProvider clientId={clientId}>{component}</OutlookProvider>;
        }

        return component;
    }
}
